/* eslint-env browser */

import el from '@finn-no/create-element';
import tracking from '@finn-no/analytics';

function lastSearchesBox(ele) {
    const noLastSearchesEle = el(
        'p.u-d1',
        null,
        'Etter hvert som du gjør søk på FINN vil de dukke opp her.'
    );

    function trackItemClick() {
        tracking.trackEventLater({
            analyticsName: 'search.repeat-recent-search.click',
            ecType: 'SEARCH',
            ecCategory: 'FrontpageLastSearchesClick',
        });
    }

    function init() {
        const panel = ele.closest('section.expansion-panel');

        // only there on mobile
        if (panel) {
            panel.addEventListener('click', () => {
                panel.classList.toggle('expansion-panel--open');
            });
        }

        const clearButton = document.getElementById('lastsearch-clear-button');
        const baseUrl = ele.getAttribute('data-lastsearch-delete-url');

        if (clearButton) {
            clearButton.addEventListener('click', (evt) => {
                evt.preventDefault();
                window
                    .fetch(baseUrl, {
                        method: 'DELETE',
                        credentials: 'include',
                    });
                const details = clearButton.parentElement;
                details.parentElement.replaceChild(noLastSearchesEle, details);
            });
        }

        const links = ele.querySelectorAll('a[name="last_search_link"]');
        links.forEach(link => link.addEventListener('click', trackItemClick));
    }
    init();
}

export default lastSearchesBox;
